<template>
  <el-card>
    <div class="header-container">
      <div class="header-status">
        <h1 class="header-text">
          {{ getStatus() }}
        </h1>
      </div>

      <div class="header-detail-container">
        <h1 class="header-code pb-2">
          <u>{{ consignment.con_full }}</u> for {{ enquiry.custom_fields.cf_customer_account }}
        </h1>
        <el-row :gutter="15">
          <el-col :span="8">
            <p>
              <b>Enquiry Type</b><br>
              <span>{{ enquiry.type }}</span>
            </p>

            <p>
              <b>Created At</b><br>
              <span>{{ $moment(enquiry.created_at).format('DD-MM-YYYY HH:mm:ss') }}</span>
            </p>
          </el-col>

          <el-col :span="8">
            <p>
              <b>Created Via</b><br>
              <span> {{ getOrigin(enquiry.source) }}</span>
            </p>

            <p>
              <b>Last Update</b><br>
              <span>{{ $moment(enquiry.updated_at).format('DD-MM-YYYY HH:mm:ss') }}</span>
            </p>
          </el-col>

          <el-col :span="8">
            <p>
              <b>Investigator</b><br>
              <span>{{ $_.get(enquiry.custom_fields.cf_freight_investigator) || '-' }}</span>
            </p>

            <p>
              <b>Portfolio</b><br>
              <span>{{ $_.get(enquiry.custom_fields.cf_portfolio) || '-' }}</span>
            </p>
          </el-col>
        </el-row>
      </div>
    </div>
  </el-card>
</template>
<script>
export default {
  props: {
    enquiry: {
      type: Object,
      required: true
    },
    consignment: {
      type: Object,
      required: true
    }
  },
  methods: {
    getStatus () {
      switch (this.enquiry.status) {
        case 2:
          return 'Open'
        case 3:
          return 'Pending'
        case 4:
          return 'Resolved'
        case 5:
          return 'Closed'
      }
    },
    getUpdatedDate () {
      return this.enquiry['enquiry_notes'][this.enquiry['enquiry_notes'].length - 1]['enq_date']
    },
    getEnquiryType () {
      let type = this.enquiry['enquiry_notes'][this.enquiry['enquiry_notes'].length - 1]['enq_type']
      switch (type) {
        case '18':
          return 'Report'
        case '19':
          return 'No Scan'
        case '20':
          return 'ETA Request'
        case '21':
          return 'Receiver Details Incorrect'
        case '22':
          return 'Short Delivery'
        case '23':
          return 'Return to Sender'
        case '24':
          return 'Redirect Freight'
        case '25':
          return 'Lost in Transit'
        case '26':
          return 'POD Request'
        case '27':
          return 'Damaged Freight'
        case '28':
          return 'Refused Freight'
        case '29':
          return 'Other'
        case '30':
          return 'Closed'
        case '31':
          return 'Re-Opened'
        case '32':
          return 'Carrier Service Complaint'
        case '33':
          return 'Internal'
        case '34':
          return 'Pre-alert'
        case '35':
          return 'Auto Generated (Tracking)'
        case '36':
          return 'Auto Generated (Urgent)'
        case '37':
          return 'Cancel Consignment'
        case '38':
          return 'Missed Pick-Up'
        case '39':
          return 'Depot Collection'
        case '40':
          return 'Imported from Email'
      }
    },
    getOrigin (origin) {
      switch (origin) {
        case 0:
          return 'Openfreight'
        case 1:
          return 'Phone'
        case 2:
          return 'Email'
        default:
          return 'OpenFreight'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "variables";
.header-container {
  display: flex;
  align-items: center;
  .header-status {
    padding: 0px 50px 0px 30px;
    .header-text {
      font-size: 2rem; text-align: center;
    }
    .status-hidden {
      color: $info;
    }
    .status-cancelled {
      color: $danger;
    }
    .status-held {
      color: $warning;
    }
    .status-error {
      color: $danger;
    }
    .status-pending {
      color: $warning;
    }
    .status-processing {
      color: $warning;
    }
    .status-processed {
      color: $primary;
    }
    .status-confirmed {
      color: $success;
    }
  }
  .header-detail-container {
    flex: 1;
    .header-code {
      cursor: pointer;
      font-size: 2rem; margin-bottom: 5px;
    }
  }
}
</style>
